import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';

import { AppState } from '@cpd-app/state';
import * as FavoriteMilitaryOccupationsActions from './favorite-occupations.actions';
import * as FavoriteMilitaryOccupationsSelectors from './favorite-occupations.selectors';

@Injectable({
  providedIn: 'root'
})
export class FavoriteMilitaryOccupationsFacade {
  readonly favoriteMilitaryOccupations$ = this.store.pipe(
    select(
      FavoriteMilitaryOccupationsSelectors.selectFavoriteMilitaryOccupations
    )
  );
  readonly favoriteMilitaryOccupationCount$ = this.store.pipe(
    select(
      FavoriteMilitaryOccupationsSelectors.selectFavoriteMilitaryOccupationCount
    )
  );

  readonly isOccupationInFavorites$ = (mocCode: string, mocTitle: string) =>
    this.store.pipe(
      select(
        FavoriteMilitaryOccupationsSelectors.selectIsOccupationInFavorites(
          mocCode,
          mocTitle
        )
      )
    );

  readonly similarMilitaryOccupations$ = this.store.select(
    FavoriteMilitaryOccupationsSelectors.selectSimilarMilitaryOccupations
  );
  readonly militaryOccupationsForGoal$ = this.store.select(
    FavoriteMilitaryOccupationsSelectors.selectMilitaryOccupationsForGoal
  );
  readonly userReclassifyingLoaded$ = this.store.select(
    FavoriteMilitaryOccupationsSelectors.selectUserReclassifyingLoaded
  );
  readonly userReclassifying$ = this.store.select(
    FavoriteMilitaryOccupationsSelectors.selectUserReclassifying
  );

  constructor(private store: Store<AppState>) {}

  public loadMilitaryFavoriteOccupations() {
    this.store.dispatch(
      FavoriteMilitaryOccupationsActions.loadMilitaryFavoriteOccupations()
    );
  }

  public addMilitaryFavoriteOccupation(mocCode: string, mocTitle: string) {
    this.store.dispatch(
      FavoriteMilitaryOccupationsActions.addMilitaryFavoriteOccupation({
        mocCode,
        mocTitle
      })
    );
  }
  public updateReclassifying(
    transitionfrommilitary: boolean,
    stayincurrent: boolean
  ) {
    this.store.dispatch(
      FavoriteMilitaryOccupationsActions.updateReclassifying({
        transitionfrommilitary,
        stayincurrent
      })
    );
  }

  public removeMilitaryFavoriteOccupation(mocCode: string, mocTitle: string) {
    this.store.dispatch(
      FavoriteMilitaryOccupationsActions.removeMilitaryFavoriteOccupation({
        mocCode,
        mocTitle
      })
    );
  }

  public loadSimilarMilitaryOccupations(
    onetCode: string,
    search?: string
  ): void {
    this.store.dispatch(
      FavoriteMilitaryOccupationsActions.loadSimilarMilitaryOccupations({
        onetCode,
        search
      })
    );
  }

  public loadMilitaryOccupationsForGoal(search?: string): void {
    this.store.dispatch(
      FavoriteMilitaryOccupationsActions.loadMilitaryOccupationsForGoal({
        search
      })
    );
  }

  public loadUserReclassifying(): void {
    this.store.dispatch(
      FavoriteMilitaryOccupationsActions.loadUserReclassifying()
    );
  }
}
